"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _framerMotion = require("framer-motion");
var _reactHamburgerMenu = _interopRequireDefault(require("react-hamburger-menu"));
var _useScroll = _interopRequireDefault(require("../../hooks/use-scroll"));
var _utils = require("../../utils/utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Packages

// Hooks

// Utils

// Styles
const {
  above,
  below,
  canHover
} = (0, _utils.getMediaQueries)();
const StyledComponentContainer = _styledComponents.default.div.withConfig({
  displayName: "main-nav__StyledComponentContainer",
  componentId: "sc-fs9ome-0"
})(["box-shadow:", ";display:flex;flex-direction:column;justify-content:center;&.unpinned{position:relative;transition-duration:0s;}&.pinned{position:sticky;top:0;transform:translateY(0);z-index:1000;&.hidden{position:sticky;top:0;transform:translateY(", ");}&.animated{transition:all 0.2s ease;}}li,li::before{all:unset;}"], props => props.$addBoxShadow && (props.$boxShadow || "0px 1px 24px rgba(153, 153, 153, 0.15)"), props => `-${props.$translateY}px`);
const StyledHeadroom = _styledComponents.default.div.withConfig({
  displayName: "main-nav__StyledHeadroom",
  componentId: "sc-fs9ome-1"
})([""]);
const StyledDesktopNavigation = _styledComponents.default.div.withConfig({
  displayName: "main-nav__StyledDesktopNavigation",
  componentId: "sc-fs9ome-2"
})(["background:white;"]);
const StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "main-nav__StyledContainer",
  componentId: "sc-fs9ome-3"
})(["max-width:1248px;min-height:120px;padding:0px 48px;margin:0 auto;display:flex;align-items:center;justify-content:", ";", ";", ""], props => props.navAlignHorizontal, below.tablet`
    min-height: 64px;
  `, below.mobile`
  padding: 0 24px;
  `);
const StyledNavItemsList = _styledComponents.default.ul.withConfig({
  displayName: "main-nav__StyledNavItemsList",
  componentId: "sc-fs9ome-4"
})(["display:flex;column-gap:12px;align-items:center;min-width:600px;justify-content:flex-end;", ";li{", "}a{position:relative;font-size:16px;line-height:20px;text-decoration:none;font-weight:400;padding:12px;transition:0.2s ease-in-out;&:not(.button)::before{content:\"\";position:absolute;width:100%;height:2px;bottom:0;left:0;background-color:var(--pacific-blue-hex);visibility:hidden;transform:scaleX(0);transition:0.3s ease-in-out;}&.active{::before{visibility:visible !important;transform:scaleX(1) !important;}}", "}"], below.tablet`
    width: auto;
    min-width: 105px;
  `, below.tablet`
      display: none;
    `, canHover`
      :hover {
        ::before {
          visibility: visible;
          transform: scaleX(1);
        }
      }
    `);
const StyledBurgerContainer = _styledComponents.default.button.withConfig({
  displayName: "main-nav__StyledBurgerContainer",
  componentId: "sc-fs9ome-5"
})(["background-color:transparent;border:none;cursor:pointer;padding:10px;transition:0.3s ease-in-out;&.desktop{display:none;}", ";.burger-time{margin-block:10px;span:nth-child(2){opacity:0 !important;}}"], below.tablet`
    &.desktop {
      display: initial;
      align-self: center;
    }
    display: initial;
    align-self: center;
  `);
const StyledModalBurgerContainer = (0, _styledComponents.default)(StyledBurgerContainer).withConfig({
  displayName: "main-nav__StyledModalBurgerContainer",
  componentId: "sc-fs9ome-6"
})(["background:#fff;display:flex;justify-content:center;width:100%;"]);
const StyledMobileNavContainer = (0, _styledComponents.default)(_framerMotion.motion.div).withConfig({
  displayName: "main-nav__StyledMobileNavContainer",
  componentId: "sc-fs9ome-7"
})(["background:#fff;border:none;width:100vw;min-height:100vh;z-index:1000;position:absolute;overflow:hidden;overflow-y:auto;top:0;bottom:0;left:0;right:0;display:flex;flex-direction:column;"]);
const StyledMobileNav = _styledComponents.default.nav.withConfig({
  displayName: "main-nav__StyledMobileNav",
  componentId: "sc-fs9ome-8"
})(["background:#fff;width:100%;"]);
const StyledMobileLinkWrapper = _styledComponents.default.div.withConfig({
  displayName: "main-nav__StyledMobileLinkWrapper",
  componentId: "sc-fs9ome-9"
})(["top:0;bottom:0;left:0;right:0;display:flex;height:100%;justify-content:center;width:100%;", "{border:none;}"], StyledMobileNav);
const StyledMobileSubNav = _styledComponents.default.div.withConfig({
  displayName: "main-nav__StyledMobileSubNav",
  componentId: "sc-fs9ome-10"
})(["border-top:1px solid var(--grey-3-hex);display:flex;flex-direction:column;padding-inline:24px;padding-block:20px;row-gap:10px;", ""], above.mobile`
    padding-inline: 48px;
  `);
const StyledMobileSubNavLabel = _styledComponents.default.div.withConfig({
  displayName: "main-nav__StyledMobileSubNavLabel",
  componentId: "sc-fs9ome-11"
})(["--margin-bottom:24px;font-weight:600;font-size:16px;line-height:24px;text-transform:uppercase;text-align:left;color:var(--dusky-grey-6-hex);margin-bottom:var(--margin-bottom);&:last-of-type{margin-top:var(--margin-bottom);}@media (max-width:950px) and (orientation:landscape){--margin-bottom:16px;padding:8px 0;}"]);
const StyledMobileNavItemsList = _styledComponents.default.ul.withConfig({
  displayName: "main-nav__StyledMobileNavItemsList",
  componentId: "sc-fs9ome-12"
})(["display:flex;flex-direction:column;row-gap:10px;padding:20px 24px;position:relative;@media (max-width:950px) and (orientation:landscape){margin-right:40px;flex:1;}a{position:relative;display:block;text-align:left;font-size:16px;line-height:20px;color:var(--orca-grey-8-hex);text-decoration:none;font-weight:400;padding:12px;margin:0;transition:0.2s ease-in-out;::before{content:\"\";position:absolute;width:100%;height:4px;bottom:0;left:0;background-color:var(--pacific-blue-hex);visibility:hidden;transform:scaleX(0);transition:0.3s ease-in-out;}", " &.active{::before{visibility:visible;transform:scaleX(1);}}}", ""], canHover`
      :hover {
        ::before {
          visibility: visible;
          transform: scaleX(1);
        }
      }
    `, above.mobile`
    padding-inline: 48px;
  `);
const StyledMobileSubNavItemsList = _styledComponents.default.ul.withConfig({
  displayName: "main-nav__StyledMobileSubNavItemsList",
  componentId: "sc-fs9ome-13"
})(["display:flex;flex-direction:column;gap:10px;a{font-size:16px;line-height:20px;text-decoration:none;&:hover{color:var(--pacific-blue-hex);}}"]);

// Main Component
function MainNav(props) {
  var _headroomRef$current2;
  const {
    scrollingDirection,
    domScrollTop,
    prevDomScrollTop
  } = (0, _useScroll.default)();
  const variants = {
    open: {
      y: 0
    },
    closed: {
      y: "-100%"
    }
  };

  // Nav scrolling animation
  const headroomRef = (0, _react.useRef)(null);
  const pinned = (0, _react.useRef)(false);
  const pinAnimation = (0, _react.useRef)(false);
  const getScrollClass = () => {
    var _headroomRef$current;
    if (props.pauseScrollingAnimation) {
      return;
    }
    let scrollClass;
    const pinStart = (_headroomRef$current = headroomRef.current) === null || _headroomRef$current === void 0 ? void 0 : _headroomRef$current.clientHeight;
    if (domScrollTop === 0) {
      pinned.current = false;
      pinAnimation.current = false;
    } else if (domScrollTop >= pinStart) pinned.current = true;
    if (pinned.current) {
      scrollClass = `pinned`;
      if (pinAnimation.current) scrollClass += ` animated`;
      if (scrollingDirection === "down" && domScrollTop >= pinStart) scrollClass += ` hidden`;
      pinAnimation.current = true;
    } else if (!pinned.current) {
      scrollClass = `unpinned`;
    }
    return scrollClass;
  };
  return /*#__PURE__*/_react.default.createElement(StyledComponentContainer, {
    $translateY: (_headroomRef$current2 = headroomRef.current) === null || _headroomRef$current2 === void 0 ? void 0 : _headroomRef$current2.offsetHeight,
    $domScrollTop: domScrollTop,
    $addBoxShadow: props.addBoxShadow,
    $boxShadow: props.boxShadow,
    className: `main-nav ${props.navFixed && getScrollClass()}`,
    $prevDomScrollTop: prevDomScrollTop,
    $scrollDirection: scrollingDirection
  }, /*#__PURE__*/_react.default.createElement(StyledHeadroom, {
    ref: headroomRef
  }, !props.navIsOpen && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledDesktopNavigation, null, props.superNav && props.superNav, /*#__PURE__*/_react.default.createElement(StyledContainer, {
    navAlignHorizontal: props.navAlignHorizontal
  }, props.logo && props.logo, props.useHamburgerMenu && /*#__PURE__*/_react.default.createElement(StyledBurgerContainer, {
    className: "desktop burger-container",
    onClick: () => props.setNavOpen(!props.navIsOpen)
  }, /*#__PURE__*/_react.default.createElement(_reactHamburgerMenu.default, {
    isOpen: props.navIsOpen,
    menuClicked: () => props.setNavOpen(!props.navIsOpen),
    animationDuration: 0.3,
    height: 8,
    width: 20,
    color: "black",
    strokeWidth: 2,
    className: "burger-time"
  })), props.navItems && /*#__PURE__*/_react.default.createElement(StyledNavItemsList, {
    className: "nav-items-list"
  }, props.navItems.map((item, i) => {
    return item;
  }))), props.subNav && props.attachSubNav && props.subNav)), props.navIsOpen && /*#__PURE__*/_react.default.createElement(StyledMobileNavContainer, {
    className: "mobile-nav-container",
    initial: {
      y: "-100%"
    },
    animate: props.navIsOpen ? "open" : "closed",
    variants: variants,
    transition: {
      default: {
        type: "spring",
        mass: 1.5,
        damping: 15,
        stiffness: 90
      }
    }
  }, props.useHamburgerMenu && /*#__PURE__*/_react.default.createElement(StyledModalBurgerContainer, {
    alt: "mobile navigation",
    onClick: () => props.setNavOpen(!props.navIsOpen)
  }, /*#__PURE__*/_react.default.createElement(_reactHamburgerMenu.default, {
    isOpen: props.navIsOpen,
    menuClicked: () => props.setNavOpen(!props.navIsOpen),
    animationDuration: 0.3,
    height: 8,
    width: 20,
    color: "black",
    strokeWidth: 2,
    className: "burger-time"
  })), /*#__PURE__*/_react.default.createElement(StyledMobileLinkWrapper, null, /*#__PURE__*/_react.default.createElement(StyledMobileNav, {
    className: "mobile-nav"
  }, /*#__PURE__*/_react.default.createElement(StyledMobileNavItemsList, {
    className: "mobile-nav-items-list"
  }, props.mobileNavItems && props.mobileNavItems.map((item, i) => {
    return item;
  })), props.mobileSubNavSections && /*#__PURE__*/_react.default.createElement(StyledMobileSubNav, {
    className: "mobile-sub-nav"
  }, props.mobileSubNavSections.map((section, i) => {
    if (!section) return null;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: `mobile-sub-nav-section-${i}`
    }, section.label && /*#__PURE__*/_react.default.createElement(StyledMobileSubNavLabel, null, section.label), /*#__PURE__*/_react.default.createElement(StyledMobileSubNavItemsList, null, (section === null || section === void 0 ? void 0 : section.items) && section.items.map((item, i) => {
      return item;
    })));
  })))))), props.subNav && !props.attachSubNav && props.subNav);
}
MainNav.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MainNav",
  "props": {
    "useHamburgerMenu": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "addBoxShadow": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "navAlignHorizontal": {
      "defaultValue": {
        "value": "\"space-between\"",
        "computed": false
      },
      "required": false
    },
    "attachSubNav": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "navFixed": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};
var _default = MainNav; // Prop Types
exports.default = _default;
MainNav.defaultProps = {
  useHamburgerMenu: true,
  addBoxShadow: true,
  navAlignHorizontal: "space-between",
  attachSubNav: true,
  navFixed: true
};